import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getPatientFormSettings } from "../../actions/settingsActions";
import BreadCrumb from "../../components/Breadcrumb";
import CreatePatientTab from "./CreatePatientTab";
import PatientListTab from "./PatientListTab";
import { getAllergies } from "../../actions/prescriptionAction";
const Patients = () => {
  const [activeSection, setActiveSection] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPatientFormSettings());
    dispatch(getAllergies());
  }, []);
  return (
    <div className="patients-page">
      <BreadCrumb pageName="Patients" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Patients</h3>
          <p className="page-desc">
            Manage your patients by viewing, adding, or removing old ones.
          </p>
          <div className="row mt-4">
            <div className="tab-wrapper">
              <div
                className={`tab ${activeSection === 0 ? "selected" : ""}`}
                onClick={() => setActiveSection(0)}
              >
                {" "}
                <h2>Patients</h2>
              </div>
              <div
                className={`tab ${activeSection === 1 ? "selected" : ""}`}
                onClick={() => setActiveSection(1)}
              >
                <h2>Create New</h2>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="detail-wrapper">
                {activeSection === 0 && <PatientListTab />}
                {activeSection === 1 && <CreatePatientTab />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Patients;
